import { WebContentSearchDto } from './dto/web-content-search.dto';
import { Injectable } from '@angular/core';
import { PagedResultGeneric } from 'src/app/shared';
import { ApiService } from '../../shared/api/api.service';
import { WebContentDto } from './dto/web-content.dto';

@Injectable({
  providedIn: 'root',
})
export class WebContentService {
  constructor(private _apiService: ApiService) {}

  search(searchDto: WebContentSearchDto): Promise<PagedResultGeneric<WebContentDto>> {
    return this._apiService.post('WebContents/AdvancedSearch', searchDto);
  }

  create(webContent: WebContentDto, fileToUpload: File = null): Promise<number> {
    const formData = new FormData();
    formData.append('webContent', JSON.stringify(webContent));
    if (fileToUpload) {
      formData.append('file', fileToUpload, fileToUpload.name);
    }
    return this._apiService.postRaw('WebContents', formData);
  }

  update(webContent: WebContentDto, file: File = null) {
    const formData = new FormData();
    formData.append('webContent', JSON.stringify(webContent));
    if (file) {
      formData.append('file', file, file.name);
    }
    return this._apiService.putRaw(`WebContent/${webContent.ContentID}`, formData);
  }

  getWebContent(webContentId: number, ignoreCache?: boolean): Promise<WebContentDto> {
    const cacheOptions = ignoreCache ? this._apiService.getDefaultApiCacheOptionsForNoCache() : null;
    return this._apiService.get(`WebContent/${webContentId}`, cacheOptions);
  }

  getWebContentFormats(): Promise<string[]> {
    return this._apiService.get('WebContents/Formats');
  }

  deleteWebContentRecord(webContentId: number): Promise<void> {
    return this._apiService.delete(`WebContent/${webContentId}`);
  }

  deleteWebContentAffCode(webContentAffCodeId: number): Promise<void> {
    return this._apiService.delete(`WebContents/WebContentAffCode/${webContentAffCodeId}`);
  }
}
